/*
 * --------------------------------------------------------------------------- *
 * File: validations.js                                                        *
 * Project: web                                                                *
 * Created Date: 07 Nov 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Wed Nov 09 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */

import { sort_unique } from "../main/utilities";

class ValidationManager {
  list = [];

  add = (v) => this.list.push(...v);

  checkClient = (data) => {
    return sort_unique(this.list)
      .filter((v) => v.owner === "client")
      .map((v) => v.method)
      .map((v) => this[v](data))
      .filter((m) => m);
  };

  check = async (data) => {
    var clientMessages = this.checkClient(data);
    // Check server
    return clientMessages;
  };

  totalOwnershipPercentageHundred = (data) => {
    console.log("Checl");
    var total = 0;
    data.owner.map((o) => o.ownershipPercentage).forEach((p) => (total += parseInt(p)));
    console.log(total);
    return total === 100 ? "" : "Total ownership percentage should add up to 100";
  };
}

export { ValidationManager };
